(() => {
  const sticky = document.querySelector('[data-aevlo-sticky]');
  const hero = document.querySelector('[data-aevlo-product-hero]');
  if (!sticky || !hero) return;

  const proxy = sticky.querySelector('.aevlo-sticky__button');
  const fallback = sticky.querySelector('.aevlo-sticky__fallback');
  const nativeForm = () => hero.querySelector('product-form-component form[action*="/cart/add"]');
  const nativeButton = () => nativeForm()?.querySelector('button[name="add"]');
  const hasSelectedVariant = () => Boolean(nativeForm()?.querySelector('input[name="id"]')?.value);

  const sync = () => {
    const price = hero.querySelector('product-price .price');
    const bundle = hero.querySelector('aevlo-bundle-selector[data-ready="true"]');
    const bundleQuantity = bundle?.quantity || 1;
    const stickyPrice = sticky.querySelector('.aevlo-sticky__price');
    if (price && stickyPrice) stickyPrice.textContent = bundleQuantity > 1 ? `${price.textContent.trim()} each` : price.textContent.trim();
    const selection = Array.from(hero.querySelectorAll('variant-picker input:checked, variant-picker select option:checked')).map((option) => option.value).join(' / ');
    const title = sticky.querySelector('.aevlo-sticky__title');
    if (title) title.textContent = bundleQuantity > 1 ? `${bundleQuantity} items — selected above` : selection;
    const button = nativeButton();
    if (!button || !hasSelectedVariant()) {
      proxy.hidden = true;
      fallback.hidden = false;
      return;
    }
    proxy.hidden = false;
    fallback.hidden = true;
    proxy.disabled = button.disabled;
    const label = button.querySelector('.add-to-cart-text__content');
    if (label) proxy.textContent = label.textContent.trim();
  };

  proxy.addEventListener('click', () => {
    const button = nativeButton();
    if (button && !button.disabled && hasSelectedVariant()) button.click();
    else document.getElementById('aevlo-purchase')?.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });

  new MutationObserver(sync).observe(hero, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled'],
  });
  hero.addEventListener('change', sync);
  sync();
})();
